import React, { useCallback, useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usersApi } from '../../../api/usersApi';
import { GetUsersResponse } from '../../../api/types';
import { USER_STATUS } from '../../../constants';

type UsersSelectProps = {
    search?: string;
    searchFields?: string[];
    label: string;
    onChange: (option: { value: string; label: string } | null) => void;
    chosenUser?: { value: string; label: string } | null;
    editedMeetingRoomBookingId?: string;
    editModeActive: boolean;
};

export const UsersSelect: React.FC<UsersSelectProps> = ({
    search,
    searchFields,
    label,
    onChange,
    chosenUser,
    editedMeetingRoomBookingId,
    editModeActive,
}) => {
    const [options, setOptions] = useState<AutoCompleteOptions>([]);

    const [getUsers, { isLoading }] = usersApi.useLazyListQuery();

    const fetchUsers = useCallback(async () => {
        getUsers({ search, searchFields, filters: { status: [USER_STATUS.ACTIVE] } })
            .unwrap()
            .then((response) => {
                const mappedResponse = mapResponseToState(response.data);
                setOptions(mappedResponse);
            });
    }, [search, searchFields]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return (
        <div>
            <Autocomplete
                loading={isLoading}
                disablePortal
                value={chosenUser}
                disabled={Boolean(!editModeActive && !!editedMeetingRoomBookingId)}
                options={options}
                renderInput={(params) => <TextField {...params} label={label} />}
                onChange={(_event, option) => {
                    onChange(option);
                }}
            />
        </div>
    );
};

type AutoCompleteOptions = { label: string; value: string }[];

function mapResponseToState(data: GetUsersResponse['data']): AutoCompleteOptions {
    return data.map((item) => ({
        label: `${item.surname} ${item.name}`,
        value: String(item.telegramUserId),
    }));
}
